export default __webpack_public_path__ + "static/media/design.64647de1.jpg";